import getHelper from '../../../services/getHelper';

import MentorStudents from '../types/MentorStudents';

export default getHelper('/mentors/:id', {
  students: getHelper<MentorStudents>('/students'),
  availableStudents: getHelper<MentorStudents>('/available-students'),
});
